import { useEffect, useRef } from 'react';
import { useDirtyGuardStore } from '@core/store';
import { DirtyGuard } from '@core/store/slices/dirtyGuardSlice';

export const useRegisterDirtyGuard = (guard: DirtyGuard) => {
    const { registerDirtyGuard, clearDirtyGuard } = useDirtyGuardStore();

    const guardRef = useRef(guard);
    guardRef.current = guard;

    useEffect(() => {
        registerDirtyGuard({
            checkDirty: () => guardRef.current.checkDirty(),
            save: () => guardRef.current.save(),
            discard: () => guardRef.current.discard()
        });
        return () => clearDirtyGuard();
    }, [registerDirtyGuard, clearDirtyGuard]);
};
